module.exports = __webpack_public_path__ + "static/media/settings.34102db0.svg";